import { Dispatch } from "redux";
import { camelize } from "../../config/functions";
import {
  getEmployees,
  getEmployeeById,
  createEmployee,
  updateEmployee,
  deleteEmployee,
} from "../../services/EmployeeService"; // your API methods
import { Employee } from "../../types/Employee";

// Action types
export enum EmployeeActionList {
  ADD_EMPLOYEE = "ADD_EMPLOYEE",
  EDIT_EMPLOYEE = "EDIT_EMPLOYEE",
  FETCH_EMPLOYEES = "FETCH_EMPLOYEES",
  DELETE_EMPLOYEE = "DELETE_EMPLOYEE",
  FETCH_EMPLOYEEBYID = "FETCH_EMPLOYEEBYID",
}

// Actions
export interface AddEmployeeAction {
  type: EmployeeActionList.ADD_EMPLOYEE;
  data: Employee;
}

export interface EditEmployeeAction {
  type: EmployeeActionList.EDIT_EMPLOYEE;
  data: Employee;
  id: number;
}

export interface FetchEmployeeAction {
  type: EmployeeActionList.FETCH_EMPLOYEES;
  data: Employee[];
}

export interface FetchEmployeeByIdAction {
  type: EmployeeActionList.FETCH_EMPLOYEEBYID;
  data: Employee[];
}

export interface DeleteEmployeeAction {
  type: EmployeeActionList.DELETE_EMPLOYEE;
  data: number;
}

export type EmployeeActions =
  | AddEmployeeAction
  | EditEmployeeAction
  | FetchEmployeeAction
  | DeleteEmployeeAction
  | FetchEmployeeByIdAction;

// Action Creators

// export const addEmployeeAction = (data: Employee) => {
//   return async (dispatch: Dispatch) => {
//     return createEmployee(data)
//       .then((response) => {
//         if ((response.status === 200) && response.data.data) {
//           const rawData = response.data.data;
//           console.log("Add Response", response);

//           dispatch<AddEmployeeAction>({
//             type: EmployeeActionList.ADD_EMPLOYEE,
//             data: rawData,
//           });

//           return Promise.resolve(response.data.message ?? "Employee added");
//         } else {
//           throw { response };
//         }
//       })
//       .catch((error) =>
//         Promise.reject(
//           error.response?.data?.message ?? "Unable to add employee"
//         )
//       );

//   };
// };

export const addEmployeeAction = (data: Employee) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await createEmployee(data);
      if (response.status === 200 && response.data.data) {
        const rawData = response.data.data;
        console.log("Add Response", response);

        dispatch<AddEmployeeAction>({
          type: EmployeeActionList.ADD_EMPLOYEE,
          data: rawData,
        });

        return response.data.message ?? "Employee added";
      } else {
        throw new Error(response.data?.message ?? "Unexpected error");
      }
    } catch (error: any) {
      throw error.response?.data?.message ?? "Unable to add employee";
    }
  };
};

export const editEmployeeAction = (id: number, data: Employee) => {
  return async (dispatch: Dispatch) => {
    return updateEmployee(id, data)
      .then((response) => {
        console.log("Update Response", response);
        if (response.status === 200 && response.data.data) {
          const rawData = response.data.data;
          dispatch<EditEmployeeAction>({
            type: EmployeeActionList.EDIT_EMPLOYEE,
            data: rawData,
            id,
          });

          return Promise.resolve(response.data.message ?? "Employee updated");
        } else {
          throw new Error(
            response.data?.message ?? "Unable to update employee",
          );
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to update employee",
        ),
      );
  };
};

export const fetchEmployeesAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getEmployees();
    dispatch<FetchEmployeeAction>({
      type: EmployeeActionList.FETCH_EMPLOYEES,
      data: response,
    });
  };
};
export const fetchEmployeesByIdAction = (employeeId: string) => {
  return async (dispatch: Dispatch) => {
    const response = await getEmployeeById(employeeId);
    dispatch<FetchEmployeeByIdAction>({
      type: EmployeeActionList.FETCH_EMPLOYEEBYID,
      data: response.data.data,
    });
  };
};

export const deleteEmployeeAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    return deleteEmployee(id)
      .then((response) => {
        if (response.status === 200) {
          dispatch<DeleteEmployeeAction>({
            type: EmployeeActionList.DELETE_EMPLOYEE,
            data: id,
          });

          return Promise.resolve(response.data.message ?? "Employee deleted");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to delete employee",
        ),
      );
  };
};
